import { render, staticRenderFns } from "./SilageTableRow.vue?vue&type=template&id=da05e410&scoped=true&lang=pug"
import script from "./SilageTableRow.vue?vue&type=script&lang=js"
export * from "./SilageTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da05e410",
  null
  
)

export default component.exports